import { useEffect } from 'react';

/**
 * BUG-S2075-001 — หน้ารายการค้างอยู่ "เลยหน้าสุดท้าย" แล้วขึ้น "ไม่พบข้อมูล" ทั้งที่ข้อมูลมีอยู่
 *
 * เกิดได้ 2 ทาง: (1) ลบรายการสุดท้ายของหน้าสุดท้าย (หน้า 2 เหลือ 0 แถว — ทางที่เกิดทุกวัน)
 * (2) เปิดลิงก์/บุ๊กมาร์ก `?page=N` หลังข้อมูลลดลง · หัวตารางบอก "ทั้งหมด 11 รายการ" แต่ตัวตาราง
 * บอก "ไม่พบ… ลองปรับตัวกรองใหม่" และ pagination หายไป = ไม่มีทางกลับ นอกจากรู้ว่าต้องลบ ?page เอง
 *
 * เลื่อนกลับไปหน้าสุดท้ายที่มีข้อมูล เมื่อโหลดเสร็จแล้ว · total = 0 ไม่แตะ (ว่างจริง)
 */
export function useClampPage(
  currentPage: number,
  totalItems: number | undefined,
  itemsPerPage: number,
  setCurrentPage: (page: number) => void,
  isLoading = false,
): void {
  useEffect(() => {
    if (isLoading || !totalItems || totalItems <= 0 || itemsPerPage <= 0) return;
    const lastPage = Math.max(1, Math.ceil(totalItems / itemsPerPage));
    if (currentPage > lastPage) setCurrentPage(lastPage);
  }, [currentPage, totalItems, itemsPerPage, isLoading, setCurrentPage]);
}

export default useClampPage;
